import { render, staticRenderFns } from "./HighExpenseExclusionInsight.vue?vue&type=template&id=86714e06&scoped=true"
import script from "./HighExpenseExclusionInsight.vue?vue&type=script&lang=js"
export * from "./HighExpenseExclusionInsight.vue?vue&type=script&lang=js"
import style0 from "./HighExpenseExclusionInsight.vue?vue&type=style&index=0&id=86714e06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86714e06",
  null
  
)

export default component.exports